import {OauthService} from './oauth.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Http} from '@angular/http';
import {App} from 'ionic-angular';
import {ToolsService} from './tools.service';
import {ToastDirective} from "../directives/toast/toast";
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class ReducceService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
    public toast: ToastDirective,
  ) {
    super(http, app, appProvider, tools);
  }


  /**
   * Get Reducce Proxy Cors By Url
   */
  getExternalData(urlOrigin: string): Observable<any> {
    const url = this.Routing.generate('proxy_cors', {}, true) + urlOrigin.replace(/^.*\/\/[^\/]+/, '');

    return this.http.get(url, {headers: this.updateHeaders()}).map(response => response.json())
  }

  /**
   * Get CGV
   */
  getCGV(): Observable<any> {
    const url = this.Routing.generate('ekipea_reducce_cgv_getcgv', {}, true);

    return this.http.get(url, {headers: this.updateHeaders()}).map(response => response.json().data)
  }

  /**
   * Check Commande
   */
  checkCommande(commandeId: number, cancel: boolean, context: string): Observable<any> {
    const param = {'_format': 'json'};
    param['commandeId'] = commandeId;
    param['cancel'] = cancel;
    param['context'] = context;

    const url = this.Routing.generate('ekipea_reducce_reducce_getcheckcommande', param, true);

    return this.http.get(url, {headers: this.updateHeaders()}).map(response => response.json().data)
  }

  /**
   * Get Statut Commande
   */
  getStatutCommande(commandeId: number): Observable<any> {
    const param = {'_format': 'json'};
    param['commandeId'] = commandeId;

    const url = this.Routing.generate('ekipea_reducce_reducce_getstatutreducce', param, true);

    return this.http.get(url, {headers: this.updateHeaders()}).map(response => response.json().data)
  }

  infoTicket(status): void {
    let text;

    switch (status) {
      case 'B' :
        text = 'Cet événement est actuellement annoncé à l\'affiche mais les réservations ne sont pas encore ouvertes.';
        break;
      case 'C' :
        text = 'Cet événement est actuellement annoncé à l\'affiche mais les réservations ne sont pas encore ouvertes.';
        break;
      case 'I' :
        text = 'Cet événement est en cours d\'annulation';
        break;
      case 'H' :
        text = 'Cet événement est annulé';
        break;
      case 'E' :
        text = 'Plus de place disponible';
        break;
      case 'K' :
        text = 'Plus de places disponibles actuellement mais des places peuvent se libérer ou être réattribuées par l\'organisateur.';
        break;
      case 'J' :
        text = 'Cet événement a été reporté';
        break;
    }

    if (text) {
      this.toast.createAdv({
        message: text,
        type: 'error'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/reducce.service.ts